import { lazy, Suspense } from 'react'

const DraftJSEditorInputComponent = lazy(() => import('.'))

export const DraftJSEditorInput: React.VFC = (props) => (
  <Suspense fallback={null}>
    <DraftJSEditorInputComponent {...props} />
  </Suspense>
)
